import { useEffect, useRef } from 'react';

/**
 * Hook that automatically dismisses a value after a delay
 * @param value - The value to watch (when truthy, starts the dismiss timer)
 * @param onDismiss - Callback to call when dismissing
 * @param delay - Delay in milliseconds before dismissing (default: 3000)
 */
export function useAutoDismiss<T>(
  value: T | null,
  onDismiss: () => void,
  delay: number = 3000
) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (value) {
      timeoutRef.current = setTimeout(() => {
        onDismiss();
      }, delay);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, onDismiss, delay]);
}
